import { GET_TENANT_LIST, GET_TENANT_DETAILS, LOGOUT_SUCCESS } from "./actions";

const initialState = {
  tenantList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  getTenantData: {},
  loading: true,
};

const tenantReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_TENANT_LIST:
      return {
        ...state,
        tenantList: payload,
        loading: false,
      };
    case GET_TENANT_DETAILS:
      return {
        ...state,
        getTenantData: payload,
        loading: false,
      };
    case LOGOUT_SUCCESS:
      return {
        tenantList: {
          docs: [],
          totalDocs: 0,
          limit: 10,
          page: 1,
          totalPages: 0,
          pagingCounter: 0,
          hasPrevPage: false,
          hasNextPage: false,
          prevPage: null,
          nextPage: null,
        },
        loading: true,
      };
    default:
      return state;
  }
};
export default tenantReducer;
